<template>
	<v-dialog
		content-class="chapters-modal overflow-x-hidden"
		v-model="innerShow"
		width="600"
		@click:outside="cancel"
	>
		<v-card class="chapters-modal__card">
			<div class="chapters-modal__card__content">
				<span class="chapters-modal__card__content__title">Post Audience</span>
				<div class="chapters-modal__card__content__wrapper">
					<div v-for="chapter in items" :key="chapter.chapter_id">
						<div class="chapters-modal__card__content__chapters">
							<CustomCheckbox
								:value="chapter.id"
								:isChecked="localValue.includes(chapter.id)"
								:onChange="() => toggleChapter(chapter.id)"
							/>
							<span class="chapters-modal__card__content__chapters__chapter">
								{{ chapter.val }}
							</span>
						</div>
					</div>
				</div>
			</div>

			<div class="chapters-modal__card__buttons">
				<button
					type="button"
					class="chapters-modal__card__buttons__cancel elevation-0"
					@click="cancel"
				>
					Cancel
				</button>
				<button
					@click="apply"
					type="button"
					class="chapters-modal__card__buttons__cancel__apply elevation-0"
				>
					Apply
				</button>
			</div>
			<button
				type="button"
				class="confirm-action-modal__button-close"
				style="background-color: #fff !important"
				@click="closeModal"
			>
				<v-icon color="#0055A3">mdi-close</v-icon>
			</button>
		</v-card>
	</v-dialog>
</template>

<script>
import CustomCheckbox from '@/components/CustomCheckbox.vue'

export default {
	components: { CustomCheckbox },
	data() {
		return {
			localValue: [],
		}
	},
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		value: {
			type: Array,
			default: () => [],
		},
		items: {
			type: Array,
			default: () => [],
		},
	},
	watch: {
		show(val) {
			if (val) {
				this.localValue = [...this.value]
			}
		},
	},

	computed: {
		innerValue: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			},
		},
		innerShow: {
			get() {
				return this.show
			},
			set(value) {
				if (!value) this.closeModal()
			},
		},
	},

	methods: {
		closeModal() {
			this.$emit('closeChaptersModal')
		},
		apply() {
			this.$emit('input', this.localValue)
			this.closeModal()
		},
		cancel() {
			this.localValue = [...this.value]
			this.closeModal()
		},
		toggleChapter(id) {
			if (this.localValue.includes(id)) {
				this.localValue = this.localValue.filter((item) => item !== id)
			} else {
				this.localValue = [...this.localValue, id]
			}
		},
	},
}
</script>
<style lang="scss">
.chapters-modal {
	border-radius: 8px;
	font-family: 'Inter', sans-serif;
	&__card {
		padding: 24px;
		display: flex;
		flex-direction: column;
		gap: 16px;
		&__content {
			display: flex;
			flex-direction: column;
			gap: 20px;
			&__wrapper {
				display: flex;
				flex-direction: column;
				gap: 12px;
			}
			&__title {
				font-weight: 700;
				font-size: 24px;
				line-height: 100%;
				letter-spacing: 0;
				color: #4a4a4a;
			}
			&__chapters {
				display: flex;
				align-items: center;
				gap: 8px;
				&__chapter {
					font-weight: 400;
					font-size: 14px;
					line-height: 100%;
					letter-spacing: 0;
					color: #4a4a4a;
				}
			}
		}
		&__buttons {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 16px;
			&__cancel {
				width: 150px;
				height: 46px;
				display: flex;
				align-items: center;
				justify-content: center;
				border: 1px solid var(--secondary_color);
				border-radius: 8px;
				font-weight: 700;
				font-size: 18px;
				line-height: 100%;
				letter-spacing: 0;
				text-align: center;
				color: var(--secondary_color);
				&__apply {
					width: 140px;
					height: 46px;
					border-radius: 8px;
					background-color: var(--primary_color);
					color: #ffffff;
					font-weight: 700;
					font-size: 18px;
					line-height: 100%;
					letter-spacing: 0;
					text-align: center;
				}
			}
		}
	}
}
</style>
